<template>
    <button v-if="show" class="btn btn-light btn-sm" type="button" @click="openLogsModal">
        view
    </button>
</template>

<script>
export default {
    name: "TableCellOrderLogs",
    props: {
        item: Object
    },
    asyncComputed: {
        async show() {
            return (await this.$store.dispatch('orderLogs/orderIds')).indexOf(this.item.id) > -1
        }
    },
    methods: {
        openLogsModal() {
            this.$store.dispatch('modals/show', {
                componentName: 'OrdersLogsModal',
                obj: {orderId: this.item.id}
            })
        }
    }
}
</script>

<style scoped>

</style>